import React from 'react';
import { useToastStore } from '../../stores/useToastStore';

const Toast: React.FC = () => {
  const { visible, message, type } = useToastStore();

  if (!visible) return null;

  const styles =
    type === 'success'
      ? 'from-emerald-600/70 to-teal-700/70 border-emerald-300/20'
      : type === 'error'
        ? 'from-rose-600/70 to-red-700/70 border-rose-300/20'
        : type === 'warning'
          ? 'from-amber-600/70 to-orange-700/70 border-amber-300/20'
          : 'from-slate-900/80 to-slate-800/80 border-white/10';

  const icon = type === 'success' ? '✅' : type === 'error' ? '❌' : type === 'warning' ? '⚠️' : 'ℹ️';

  return (
    <div className="fixed top-20 left-1/2 -translate-x-1/2 z-[1100] w-[80vw] max-w-full px-4">
      <div
        className={`bg-gradient-to-r ${styles} text-white/90 text-sm px-4 py-2.5 rounded-xl shadow-xl border backdrop-blur-md flex items-center gap-2 animate-[fadeIn_150ms_ease-out] w-full`}
      >
        <span className="text-sm leading-none opacity-90 flex-shrink-0">{icon}</span>
        <span className="leading-none break-words">{message}</span>
      </div>
    </div>
  );
};

export default Toast;
